module.exports = __webpack_public_path__ + "img/empty.a776360e.png";